module.exports = __webpack_public_path__ + "static/media/Qatar.448a60d3.png";